"use client";

import { AdChoicesLink } from "@/components/common/Footer/AdChoicesLink";
import MarketingLink from "@/components/common/LinkHandler/MarketingLink";
import { Logo } from "@/components/icons/Logo";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";

import { data } from "./data";
import styles from "./FooterReallySimple.module.scss";

type FooterLink = {
  link: string;
  title: string;
};

interface FooterData {
  policy: FooterLink[];
}

interface LinkListProps {
  list: FooterLink[];
}

const currentYear: number = new Date().getFullYear();
const copyrightText: string = `© ${currentYear} Nutraceutical Wellness Inc. All Rights Reserved.`;

const STATEMENT: string =
  "These statements have not been evaluated by the Food and Drug Administration.";
const STATEMENT2: string =
  "This product is not intended to diagnose, treat, cure, or prevent any disease.";

const LinkList = ({ list }: LinkListProps) => {
  const linkList = list.map((el: FooterLink, idx: number) => {
    if (el.link === "adchoices") {
      const cls: string = process.env.NEXT_PUBLIC_RENDER_CSP === "1" ? "block" : "hidden";
      return (
        <div className={cn(styles.link, styles.adchoices, cls)} key={`${el.link}-${idx}`}>
          <AdChoicesLink isLightTheme />
        </div>
      );
    }

    return (
      <div
        className={cn(styles.link, el.title.toLowerCase().replace(/\s/g, "-"))} // Convert title to a valid class name
        key={`${el.link}-${idx}`}
      >
        <MarketingLink path={el.link} ariaLabel={el.title}>
          <TextElementNova
            element="span"
            className="Body-10-Dia-Normal text-nova-base-black"
            text={el.title}
          />
        </MarketingLink>
      </div>
    );
  });
  return <>{linkList}</>;
};

export const FooterReallySimple = () => {
  const typedData: FooterData = data as FooterData;

  return (
    <footer className={cn(styles.footerContainer, "w-full bg-nova-base-white")} data-mousedown>
      <div className={cn(styles.mainBox)}>
        <div className={cn(styles.leftSide)}>
          <div className="flex flex-col md:flex-row items-start text-left">
            <div className={cn(styles.logoWrap, "mb-4 md:mb-0 md:mr-6")}>
              <Logo className="text-nova-brand-primary-80 w-10 h-10" />
            </div>
            <div className={cn(styles.contentWrapper)}>
              <TextElementNova
                element="p"
                text={copyrightText}
                className="Body-10-Dia-Normal text-nova-base-black"
              />
              <TextElementNova
                element="p"
                text={STATEMENT}
                className="Body-10-Dia-Normal text-nova-base-black"
              />
              <TextElementNova
                element="p"
                text={STATEMENT2}
                className="Body-10-Dia-Normal text-nova-base-black"
              />
            </div>
          </div>
        </div>

        <div className={cn(styles.rightSide)}>
          <div className={cn(styles.styledLinks, "col-legal-s")}>
            <TextElementNova
              element="h3"
              className={cn(
                styles.sectionHeader,
                "Caption-10-Dia-Uppercase text-nova-transparency-black-60"
              )}
              text="Legal"
            />
            <LinkList list={typedData.policy} />
          </div>
        </div>
      </div>
    </footer>
  );
};
